import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { useToast } from '../../contexts/ToastContext';
import './AdminSettings.css';

const AdminSettings: React.FC = () => {
  const [featuredMax, setFeaturedMax] = useState<string>('3');
  const [saving, setSaving] = useState(false);
  const { success, error: showError } = useToast();

  useEffect(() => {
    const fetchSetting = async (): Promise<void> => {
      try {
        const response = await api.get<{ key: string; value: string | null }>('/admin/settings/ArtistFeaturedMax');
        if (response.data.value) {
          setFeaturedMax(response.data.value);
        }
      } catch (error) {
        console.error('Failed to load settings', error);
      }
    };
    fetchSetting();
  }, []);

  const saveSetting = async (): Promise<void> => {
    setSaving(true);
    try {
      await api.put('/admin/settings/ArtistFeaturedMax', { value: featuredMax });
      success('Settings saved');
    } catch (error) {
      showError('Failed to save settings');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-settings">
      <div className="container">
        <div className="page-header">
          <div className="page-header-left">
            <Link to="/admin" className="back-button">
              <i className="fas fa-arrow-left"></i> Back to Admin Panel
            </Link>
            <h1>Admin Settings</h1>
          </div>
        </div>

        <div className="settings-card">
          <h2>Artist Highlights</h2>
          <div className="form-group">
            <label>Max Featured Pieces per Artist</label>
            <input
              type="number"
              min="1"
              value={featuredMax}
              onChange={(e) => setFeaturedMax(e.target.value)}
            />
          </div>
          <button className="btn btn-primary" onClick={saveSetting} disabled={saving}>
            {saving && <span className="btn-spinner" aria-hidden="true"></span>}
            {saving ? 'Saving...' : 'Save Settings'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;
